export const getCategoryImage = (categoryPhoto: string, uploadedFile: File | null) => {
  if (uploadedFile) return URL.createObjectURL(uploadedFile);
  if (!!categoryPhoto) return categoryPhoto;
  return '/images/no-image.jpeg';
};
